import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import AttachmentsList from 'src/components/AttachmentsList/AttachmentsList'
import Trns from 'src/localization/Trns'
import { ReceiptAttachmentModel } from 'src/models/receiptAttachment.models'
import { PostReceiptAttachmentRequest } from 'src/requests/postReceiptAttachment.request'
import { css } from 'styled-components'

interface AttachmentsInputFieldProps {
  onChange?: (value: number | undefined) => void
  value?: number
  type?: string
  receiptAttachments: ReceiptAttachmentModel[]
  uploadingAttachmentThumbnails?: Record<string, string>
  uploadAttachments?: (attachments: PostReceiptAttachmentRequest[]) => void
  deleteAttachment: (attachmentId: string) => void
  id?: string
  setAttachmentError?: (
    errorMsg: string | React.ReactElement | undefined,
  ) => void
  additionalContextCopy?: React.ReactElement
}

const AttachmentsInputField: React.FC<AttachmentsInputFieldProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            14,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
          margin-bottom: 32px;
        `}
      >
        {props.additionalContextCopy ?? (
          <Trns
            source={
              'Use this space to attach approvals, invoices, and other documents. You will be able to add receipts later to each transaction.'
            }
          />
        )}
      </span>
      <AttachmentsList
        attachments={props.receiptAttachments}
        uploadingAttachmentThumbnails={props.uploadingAttachmentThumbnails}
        uploadAttachments={props.uploadAttachments}
        deleteAttachment={props.deleteAttachment}
        id={props.id}
        setAttachmentError={props.setAttachmentError}
      />
    </div>
  )
}

export default React.memo(AttachmentsInputField)
